<template>
<div>
    <div class="add-viaFtp-cont-body">
        <div>
            <span class="add-ftp-des" style="position:relative;left:-5Px;" v-html="$t('language.popup.addCloudPopup.addNasFtpDes')"></span>
        </div>
        <div class="ftp-input-line">
            <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.displayName')}}</font>

            <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="text" name="" class="via-ftp-input" v-model="displayName" />
        </div>
        <div class="ftp-input-line">
            <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.server')}}</font>
             <div class="question-mark" style="float:right;position:absolute;">
                <div class="icon-util question" id='viaFtp'>
                    <div class="via-ftp-explanation">
                        <font v-html="$t('language.popup.addCloudPopup.explanation')"></font>
                    </div>
                </div>
            </div>
            <input  type="text" class="ftp-cont-right-one" v-model="port" />
            <input :style="{width:this.$i18n.locale =='italian'?'260Px':''}" type="text" class="ftp-cont-input" v-model="httpName" />
          
        </div>
        <div class="ftp-input-line">
            <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.userName')}}</font>
            <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="text" class="ftp-cont-three" v-model="email" />
        </div>
        <div class="ftp-input-line">
            <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
            <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="password" class="ftp-cont-three" v-model="password" />
        </div>
        <div class="advanced">
            <div class="advanced-menu">
                <font class="advanced-text" id="advancedText" @click="advancedDivShow()">{{$t('language.popup.addCloudPopup.advanced')}}
                    <div class="icon-util folding-panel slide" :class="{'folding-panel-up':advancedShow}" id="iconUtil"></div>
                </font>
            </div>
        </div>
    </div>
    <transition name="ftp-slide">
        <div class="add-ftp-buttom" v-show="advancedShow" v-cloak style="margin-left: 5Px;min-width: 610Px;padding-right:25Px;">
            <div class="advanced-item">
                <font class="via-advanced-name">{{$t('language.popup.addCloudPopup.transMode')}}</font>
                <span style="float:left;"  :style="{marginLeft:this.$i18n.locale =='italian'?'26Px':''}">
                    <cloud-select :selectOption="transferMode" @changeOption="changeTransferMode" :placeholder="selectModeValue"></cloud-select>
                </span>
            </div>
            <div class="advanced-item">
                <font class="via-advanced-name">{{$t('language.popup.addCloudPopup.encoding')}}</font>
                <span style="float:left;"  :style="{marginLeft:this.$i18n.locale =='italian'?'26Px':''}">
                    <cloud-select :selectOption="enCoding" @changeOption='onChangeCharSet' :placeholder="selectCodValue"></cloud-select>
                </span>
            </div>
            <div class="ftp-input-line">
                <font class="cloud-viaWeb-name">{{$t('language.popup.addCloudPopup.path')}}</font>
                <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="text" class="ftp-cont-three" v-model="path" :class="advancedShow&&!SftpShow?'path-input':''" />
            </div>
        </div>
    </transition>
</div>
</template>

<script>
import cloudSelect from '@/components/common/select/cloud_select';
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            cloudInfo: {},
            ftpDialog: false,
            cloudName: '',
            cloudIcon: '',
            advancedShow: false, //控制高级选项是否显示
            foldingPanel: '',
            addFtp: '',
            selectValue: 'FTP',
            selectOption: [{
                name: 'FTP'
            }, {
                name: 'SFTP'
            }, {
                name: 'FTPS'
            }],
            commonFTP: [{
                name: 'Default'
            }, {
                name: 'Box'
            }, {
                name: 'ADrive'
            }, {
                name: 'Egnyte'
            }], //下拉框赋值
            selectFTPValue: 'Default', //用于存储FTP默认值
            transferMode: [{
                name: 'Passive'
            }, {
                name: 'active'
            }],
            selectModeValue: 'Passive',
            enCoding: [{
                name: 'Autodetect'
            }, {
                name: 'UTF-8'
            }, {
                name: 'ISO-8859-1'
            }, {
                name: 'GB2312'
            }, {
                name: 'GBK'
            }], //encoding下拉框赋值
            selectCodValue: 'Autodetect',
            explanShow: false, //用于定义弹框是否显示
            connect: false,
            displayName: 'NAS',
            httpName: 'ftp://',
            SftpShow: false,
            optional: '',
            email: '',
            password: '',
            path: '',
            port: '21',
            serverUrl: '',
            charSet: 'Autodetect',
            commonFtpName: 'Default',
            transferModeValue: 'Passive'
        }
    },
    mounted() {
        this.$parent.$parent.$parent.$refs.nasDiv.style.height = 470 + 'px';
    },
    components: {
        "cloud-select": cloudSelect
    },
    methods: {
        onChangeOption(newValue) {
            let that = this;
            switch (newValue) {
                case 'FTP':
                    this.displayName = newValue;
                    this.cloudName = newValue;
                    this.httpName = 'ftp://';
                    this.SftpShow = false;
                    if (this.advancedShow) {
                        this.$parent.$parent.$parent.$refs.nasDiv.style.height = 630 + 'px';
                    } else {
                        this.$parent.$parent.$parent.$refs.nasDiv.style.height = 470 + 'px';
                    }
                    break;
                case 'SFTP':
                    this.displayName = newValue;
                    this.cloudName = newValue;
                    this.httpName = 'sftp://';
                    this.SftpShow = true;
                    this.$nextTick(function () {
                        if (that.advancedShow) {
                            this.$parent.$parent.$parent.$refs.nasDiv.style.height = 785 + 'px';
                        } else {
                            this.$parent.$parent.$parent.$refs.nasDiv.style.height = 630 + 'px';
                        }
                    });
                    break;
                case 'FTPS':
                    this.displayName = newValue;
                    this.cloudName = newValue;
                    this.httpName = 'ftps://';
                    this.SftpShow = false;
                    if (this.advancedShow) {
                        this.$parent.$parent.$parent.$refs.nasDiv.style.height = 630 + 'px';
                    } else {
                        this.$parent.$parent.$parent.$refs.nasDiv.style.height = 470 + 'px';
                    }
                    break;
            }
        },
        onChangeOptionTwo(newValue) {
            this.commonFtpName = newValue;
            this.$refs.cloudSelect.currentValue = 'FTP';
            switch (newValue) {
                case 'Default':
                    this.displayName = 'FTP';
                    this.cloudName = 'FTP';
                    this.httpName = 'ftp://';
                    this.SftpShow = false;
                    this.$parent.$parent.$parent.$refs.nasDiv.style.height = 630 + 'px';

                    break;
                case 'Box':
                    this.displayName = 'FTP-Box';
                    this.cloudName = 'FTP';
                    this.httpName = 'ftp://ftp.box.com';
                    this.SftpShow = false;
                    this.$parent.$parent.$parent.$refs.nasDiv.style.height = 630 + 'px';
                    break;
                case 'ADrive':
                    this.displayName = 'FTP-ADrive';
                    this.cloudName = 'FTP';
                    this.httpName = 'ftp://ftp.adrive.com';
                    this.SftpShow = false;
                    this.$parent.$parent.$parent.$refs.nasDiv.style.height = 630 + 'px';
                    break;
                case 'Egnyte':
                    this.displayName = 'FTPS-Egnyte';
                    this.cloudName = 'FTPS';
                    this.httpName = 'ftps://ftp-domain.egnyte.com';
                    this.SftpShow = false;
                    this.$parent.$parent.$parent.$refs.nasDiv.style.height = 630 + 'px';
                    break;
            }
        },
        onChangeCharSet(newValue) {
            switch (newValue) {
                case 'Autodetect':
                    this.charSet = newValue
                    break;
                case 'UTF-8':
                    this.charSet = newValue
                    break;
                case 'ISO-8859-1':
                    this.charSet = newValue
                    break;
                case 'GB2312':
                    this.charSet = newValue
                    break;
                case 'GBK':
                    this.charSet = newValue
                    break;
            }
        },
        changeTransferMode(newValue) {
            this.transferModeValue = newValue;
        },
        letExplanShow() {
            this.explanShow = true;
        },
        advancedDivShow() {
            this.advancedShow = !this.advancedShow;
            if (this.advancedShow && this.SftpShow) {
                this.$parent.$parent.$parent.$refs.nasDiv.style.height = 785 + 'px';
            } else if (this.SftpShow || this.advancedShow) {
                this.$parent.$parent.$parent.$refs.nasDiv.style.height = 630 + 'px';
            } else {
                this.$parent.$parent.$parent.$refs.nasDiv.style.height = 470 + 'px';
            }
        }
    }
}
</script>

<style>
#questionMark:hover .ftp-explanation {
    display: block;
    cursor: pointer;
}

#addFtp {
    width: 680px;
    /*no*/
    height: 470px;
    /*no*/
}

.add-ftp-cont {
    width: 620px;
    /*no*/
    padding: 0 40px 0px 20px;
    /*no*/
}

.add-viaFtp-cont-body {
    width: 610Px;
    padding-top: 15px;
    /*no*/
    height: 265px;
    /*no*/
    margin-left: 5Px;
    box-sizing: border-box;
}

.via-ftp-buttom {
    width: 600Px;
    height: 180px;
    /*no*/
}

.add-ftp-text {
    width: 100%;
    height: 180px;
    /*no*/
}

.path-input {
    margin-bottom: 20px;
    /*no*/
}

.add-ftp-text textarea {
    width: 100%;
    height: 120px;
    /*no*/
    box-sizing: border-box;
    padding: 15px 10px 0px 15px;
    /*no*/
    border: 1px solid #d4edfa;
    /*no*/
    font-size: 14px;
    /*no*/
    /*no*/
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    resize: none;
    color: #6f7886;
    margin-top: 5px;
    /*no*/
    white-space: pre-wrap !important;
}

.add-ftp-text textarea::-webkit-input-placeholder {
    color: #ccc;
}

.add-ftp-text textarea:focus {
    border: 1px solid #8a96e3;
    /*no*/
    outline: none;
}

.add-ftp-des {
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.55);
}

.ftp-cont-three {
    width: 480px;
    /*no*/
    float: right;
    color: rgba(0, 0, 0, 0.6);
    ;
}

.ftp-input-line {
    float: right;
    width: 100%;
}

.via-advanced-name {
    font-size: 14px;
    /*no*/
    float: left;
    width: 124px;
    /*no*/
    text-align: left;
}

.drive-add-ftps {
    width: 100%;
    height: 47.5%;
    text-align: center;
    margin-top: 2%;
    border-bottom: 1px solid #FFF;
    /*no*/
}

.select-ftp-value {
    width: 178px;
    /*no*/
    height: 136px;
    /*no*/
    position: absolute;
    z-index: 1;
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid #8A96E3;
    /*no*/
    border-top: none;
    background: #FFF;
    left: 130px;
    /*no*/
    top: 44px;
    /*no*/
}

.ftp-slide-enter-active {
    transition: all 0.5s ease;
    height: 100px;
    /*no*/
    overflow: hidden;
}

.ftp-slide-leave-active {
    transition: all 0s ease;
    height: 0px;
    /*no*/
    overflow: hidden;
}

.ftp-slide-enter,
.ftp-slide-leave {
    height: 0;
    opacity: 0;
}

.via-ftp-input {
    width: 480Px;
    float: right;
    color: rgba(0, 0, 0, 0.6);
}

.via-ftp-explanation {
    display: none;
    width: 350Px;
    border: 1Px solid #8a96e3;
    font-size: 12Px;
    position: relative;
    background-color: #fff;
    padding: 5Px;
    left: -360Px;
    bottom: 79Px;
    float: left;
    min-height: 68Px;
}

#viaFtp {
    position: relative;
    left: 610Px;
    top: 18Px;
    float: right;
}

.question-mark:hover .via-ftp-explanation {
    display: block !important;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_add_cloud/tab_via_ftp.vue